import React, { useEffect, useState, useContext } from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom'

import AuthService from '../../utilities/services/auth.service'
import UserContext from '../../context/User/User'

import {
  login,
  getMe,
  getOrganizationSessionContext,
} from '../../utilities/api'

import Stack from 'react-bootstrap/Stack'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

import { PasswordInput } from '../PasswordInput'
import { Error } from '../Error'
import { Spinner } from '../LoadingContainer/Spinner'

export default function LoginWrapper() {
  const { setAuthenticated, setOrganization } = useContext(UserContext)
  const {
    setUser,
    setPermissions,
    setOrg,
    setProfile,
    applyOrganizationSession,
    setSuperAdminOrganizerSession,
    getOrg,
  } = AuthService

  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from?.pathname || '/'

  const [credentials, setCredentials] = useState({
    identifier: '',
    password: '',
  })

  const [isValid, setIsValid] = useState(true)

  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    if (!isValid) setIsValid(true)
  }, [credentials.identifier, credentials.password])

  const handleCredentials = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value })
  }

  const submit = (e) => {
    e.preventDefault()
    if (isValid) {
      setIsSaving(true)
      login(credentials)
        .then(async (res) => {
          let me = await getMe(res.data.jwt)
          if (me.data.organizations.length > 0) {
            setProfile(me.data.profile?.pos_terminal)
          } else {
            console.error('No Org Present')
            return
          }
          setUser({
            ...res.data,
            user: {
              ...res.data.user,
              superAdmin: me.data.superAdmin,
              role: me.data.role ?? res.data.user?.role,
            },
          })
          setAuthenticated(res.data)
          setPermissions(me?.data?.organization_role)
          try {
            const sc = await getOrganizationSessionContext()
            setSuperAdminOrganizerSession(
              Boolean(sc?.data?.isSuperAdminOrganizer)
            )
            const sessionOrgs = sc?.data?.organizations
            if (sessionOrgs?.length) {
              const savedUuid = localStorage.getItem('activeOrganizationUuid')
              const activeUuid =
                savedUuid && sessionOrgs.some((o) => o.uuid === savedUuid)
                  ? savedUuid
                  : sessionOrgs[0].uuid
              applyOrganizationSession(sessionOrgs, activeUuid)
              setOrganization(getOrg()[0])
            } else {
              setOrg(me.data.organizations)
              setOrganization(me.data.organizations[0])
            }
          } catch {
            setSuperAdminOrganizerSession(
              Boolean(me.data.superAdmin && me.data.role?.name === 'Organizer')
            )
            setOrg(me.data.organizations)
            setOrganization(me.data.organizations[0])
          }
          // Send them back to the page they tried to visit when they were
          // redirected to the login page. Use { replace: true } so we don't create
          // another entry in the history stack for the login page.  This means that
          // when they get to the protected page and click the back button, they
          // won't end up back on the login page, which is also really nice for the
          // user experience.
          setIsSaving(false)
          navigate(from, { replace: true })
        })
        .catch((err) => {
          setIsValid(false)
          setIsSaving(false)
          console.error(err)
        })
    }
  }

  return (
    <section className="wrapper-xs">
      <header className="mb-5">
        <h1 className="fs-md">Organizer login</h1>
        <h2 className="text-muted normal fw-medium">
          The future of ticketing is here
        </h2>
      </header>
      <Form onSubmit={submit}>
        <Form.Group className="form-group" controlId="identifier">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            name="identifier"
            required
            placeholder="e.g mail@example.com"
            value={credentials.identifier}
            onChange={handleCredentials}
            className={`${!isValid ? 'error-border' : ''}`}
          />
        </Form.Group>
        <Form.Group className="form-group" controlId="password">
          <Form.Label>Password</Form.Label>
          <PasswordInput
            value={credentials.password}
            isValid={isValid}
            handlePassword={handleCredentials}
          />
          <Stack direction="horizontal">
            <Link to="forgot-password" className="mt-2 ms-auto caption">
              Forgot password?
            </Link>
          </Stack>
        </Form.Group>
        {!isValid && <Error type="login" />}
        <Button
          type="submit"
          size="lg"
          className={`btn-width mt-4 w-100 ${!isSaving ? 'btn-next' : ''} `}
          disabled={
            credentials.identifier === '' ||
            credentials.password === '' ||
            isSaving ||
            !isValid
          }
        >
          {isSaving ? <Spinner /> : 'Login'}
        </Button>
      </Form>
      {/* <div className="text-center mt-4 caption">
        <span className="text-muted">
          Don't have an account yet? <Link to="/signup">Signup</Link>
        </span>
      </div> */}
    </section>
  )
}
